export default __webpack_public_path__ + "static/7-acd22f56d0e155293df685e92fd7aa43.png";